<template>
	<div class="animated fadeIn">
		<b-row>
			<b-col sm="12">
				<b-card header-tag="header" footer-tag="footer" no-body>
					<div slot="header" class="planheader">
						<strong class="float-left mt-1">Daily Plan Master</strong>
						<router-link v-if="user_type == 1"
							class="btn-md ml-5 font-weight-bold text-white graybutton float-left d-block"
							:to="{path:'/nlh_dashboard'}" target="_blank">National
							Line haul
							<!-- <a :href="row.item.file_path" target="blank">
								<i class="fa fa-eye"></i>
							</a> -->
						</router-link>

						<router-link v-if="user_type !== 1"
							class="btn-md ml-5 font-weight-bold text-white graybutton float-left d-block"
							:to="{path:'/unloadingPlans'}" target="_blank">Unloading Plans
							<!-- <a :href="row.item.file_path" target="blank">
								<i class="fa fa-eye"></i>
							</a> -->
						</router-link>

						<router-link v-if="user_type == 1"
							class="btn-md ml-5 font-weight-bold text-white orangebutton float-right d-block"
							:to="{path:'/newPlanUpload', query:{from:'addplan'}}">Add Plan
							<!-- <a :href="row.item.file_path" target="blank">
								<i class="fa fa-eye"></i>
							</a> -->
						</router-link>
						<!-- <b-button class="btn-md ml-5 font-weight-bold text-white graybutton">National Line haul</b-button>
						<button class="btn btn-primary btn-md float-right font-weight-bold text-white orangebutton">Add
							Plan</button> -->
					</div>
					<div class="tabwrapper">
						<b-tabs pills>
							<b-tab title="Adhoc Vehicle Plan" title-item-class="tabbutton" class="tabbutton text-center"
								@click="activeTab = 1">
								<div class="container1">
									<form>
										<div class="form-row1">
											<div class="form-group1" v-if="user_type == 1">
												<b-form-select v-model="selected_warehouse" class="ml-2">
													<option value="">Select Warehouse</option>
													<option :value="hub.hubid" v-for="hub in optionsWH" :key="hub.hubid">{{hub.hubname}} -
														{{hub.hubid}}</option>
												</b-form-select>
											</div>

											<div class="form-group1">
												<label class="mb-1 mr-2 font-weight-bold">Planning From Date:</label>
												<v-date-picker class="custom-date-picker" :available-dates='{ start: null, end: new Date() }'
													v-model='selectDateFrom'>
												</v-date-picker>
											</div>

											<div class="form-group1">
												<label class="ml-2 mb-1 font-weight-bold">Planning To Date:</label>
												<v-date-picker class="custom-date-picker" :available-dates='{ start: null, end: new Date() }'
													v-model='selectDateTo'>
												</v-date-picker>
											</div>

											<div class="form-group1">
												<b-form-select v-model="planstatus" class="ml-3">
													<option value="">Plan Status</option>
													<option value="open">Open</option>
													<option value="close">Close</option>
												</b-form-select>
											</div>

											<div class="form-group1">
												<b-form-select v-model="plantype" class="ml-1">
													<option value="">Plan Type</option>
													<option value="DD">Direct Delivery(DD)</option>
													<option value="LH">Line Haul(LH)</option>
													<option value="NLH">National Line Haul(NLH)</option>
												</b-form-select>
											</div>

											<div class="form-group1 ml-0">
												<label class=""><b>Total Records :</b></label>
												<div class="mt-2">
													<b>
														<p> <span style="color:red; font-size: 12px;"> {{totalRecord}}</span></p>
													</b>
												</div>
											</div>
										</div>
									</form>
								</div>

								<b-row>
									<b-col class="mt-3 mb-3">
										<b-button class="custom-green-button btn-black" variant="success"
											@click="applySearch()">Search</b-button>
										<b-button variant="danger" class="ml-2 btn-black" @click="clearFilter()">Clear</b-button>

										<b-button class="ml-2 btn-black" @click="downloadConsolidateCsv()">Download Consolidate Excel
											File <a :href=conslidateUrl></a>
										</b-button>
										<!-- </a> -->
									</b-col>
								</b-row>

								<!-- <div>
							<b-tab title="Adhoc Vehicle Plan" title-item-class="tabbutton" class="tabbutton text-center"
								@click="activeTab = 1">

								<div>
									<b-row>
										<b-col sm="2">
											<div>
												<b-form-group>
													<b-form-select v-model="selected_warehouse" class="mb-3">
														<option value="">-- Select Warehouse --</option>
														<option :value="wh.id" v-for="wh in optionsWH" :key="wh.id">{{wh.name}}</option>

													</b-form-select>
												</b-form-group>
											</div>
										</b-col>

										<b-col sm="2">
											<b-form-group class="font-weight-normal" label="Planning From Date:" :label-cols="4">
												<v-date-picker mode='single' input-class="dateInput"
													:available-dates='{ start: null, end: new Date() }' v-model='selectDateFrom'>
												</v-date-picker>
											</b-form-group>
										</b-col>

										<b-col sm="3">
											<b-form-group class="font-weight-normal" label="Planning To Date:" :label-cols="4">
												<v-date-picker mode='single' input-class="dateInput"
													:available-dates='{ start: null, end: new Date() }' v-model='selectDateTo'>
												</v-date-picker>
											</b-form-group>
										</b-col>

										<b-col sm="2">
											<b-form-group>
												<b-form-select v-model="planstatus" class="mb-3">
													<option value="">-- Plan Status --</option>
													<option value="open">Open</option>
													<option value="close">Close</option>
												</b-form-select>
											</b-form-group>
										</b-col>

										<b-col sm="2">
											<b-form-group>
												<b-form-select v-model="plantype" class="mb-3">
													<option value="">Plan Type</option>
													<option value="DD">Direct Delivery(DD)</option>
													<option value="LH">Line Haul(LH)</option>
													<option value="NLH">National Line Haul(NLH)</option>
												</b-form-select>
											</b-form-group>
										</b-col>

										<b-col>
											<p> <b>Total Records :<span style="color:red;"> {{totalRecord}}</span></b> </p>
										</b-col>

										<b-col>
											<b-button class="custom-green-button" variant="success" @click="applySearch()">Search</b-button>
											<b-button variant="danger" class="ml-2">Clear</b-button>
											<b-button class="ml-2">Download Consolidate Excel File</b-button>
										</b-col>


									</b-row>
								</div> -->
								
								<div class="accordion" role="tablist">

									<b-card no-body class="mb-1" v-for="(locations, location) in plandata" :key="location">
										<b-card-header header-tag="header" class="p-1" role="tab">
											<b-button block v-b-toggle="'accordion-1' + location" class="text-left">
												{{ location.charAt(0).toUpperCase() + location.slice(1) }}
												<!-- <span style="cursor: pointer;" @click="toggleCollapse(location)">
													<i :class="isOpen(location) ?  'fas fa-plus' : 'fas fa-minus'"></i>
												</span> -->
											</b-button>
										</b-card-header>
										<b-collapse :id="'accordion-1' + location" :visible="isOpen(location)">
											<!-- style="overflow:auto;" role="tabpanel"  accordion="my-accordion"  -->
											<b-card-body class="p-0" style="overflow: auto;">
												<div class="table-responsive">
													<b-table class="m-0" show-empty stacked="md" :busy="isBusy" :items="locations"
														:fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter"
														:sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection"
														@filtered="onFiltered" :bordered="bordered">

														<div slot="table-busy" class="text-center text-danger my-2">
															<b-spinner class="align-middle"></b-spinner>
															<strong>Loading...</strong>
														</div>

														<template slot="srno" slot-scope="row">
															<span>{{row.index + 1}}</span>
														</template>

														<template slot="planid" slot-scope="row">
															<span>{{row.item.planid}}</span>
														</template>

														<template slot="vehicleno" slot-scope="row">
															<span class="href_vehicleNumber" @click="showVehicleDetails(row.item)" v-if="row.item.vehicleno!='NA'">{{row.item.vehicleno}}</span>
															<span v-else>NA</span>
														</template>

														<template slot="vendorname" slot-scope="row">
															<span>{{row.item.vendorname ? row.item.vendorname.charAt(0).toUpperCase() +
																row.item.vendorname.slice(1) : row.item.vendorname}}</span>
														</template>

														<template slot="plandate" slot-scope="row">
															<span>{{row.item.plandate}}</span>
														</template>

														<template slot="route" slot-scope="row">
															<span>{{row.item.route ? row.item.route.charAt(0).toUpperCase() + row.item.route.slice(1):
																row.item.route}}</span>
														</template>

														<template slot="valweight" slot-scope="row">
															<span>{{row.item.valweight}}</span>
														</template>

														<template slot="plantype" slot-scope="row">
															<span>{{row.item.plantype ? row.item.plantype.charAt(0).toUpperCase() +
																row.item.plantype.slice(1) : row.item.plantype}}</span>
														</template>

														<template slot="plantatus" slot-scope="row">
															<span>{{row.item.plantatus ? row.item.plantatus.charAt(0).toUpperCase() +
																row.item.plantatus.slice(1): row.item.plantatus}}</span>
														</template>

														<template slot="destination" slot-scope="row">
															<span>{{row.item.destination.join(', ') }}</span>
														</template>

														<template slot="destinationPoints" slot-scope="row">
															<span>{{row.item.destination.length}}</span>
														</template>

														<template slot="loadcount" slot-scope="row">
															<span>{{row.item.loadcount}}</span>
														</template>

														<template slot="boxcount" slot-scope="row">
															<span>{{row.item.boxcount}}</span>
														</template>

														<template slot="tripid" slot-scope="row">
															<span>{{row.item.tripid}}</span>
														</template>

														<template slot="currentloc" slot-scope="row">
															<span>{{row.item.currentloc ? row.item.currentloc.charAt(0).toUpperCase() +
																row.item.currentloc.slice(1) : row.item.currentloc}}</span>
														</template>
														<template slot="distancecovered" slot-scope="row">
															<span>{{row.item.distancecovered}}</span>
														</template>

														<template slot="downloadfile" slot-scope="row">

															<b-button size="sm" class="mr-2" @click="downloadAdhocFile(row.item.planid)">
																<i class="fas fa-download"></i>
																<a :href="adhocPlanCsvUrl"></a>
															</b-button>

														</template>

														<template slot="action" slot-scope="row">
															<b-button size="sm" class="mr-2" @click="showModal(row)">
																<i class="fas fa-edit" aria-hidden="true"></i>
															</b-button>
														</template>

													</b-table>
												</div>
											</b-card-body>
										</b-collapse>
									</b-card>

									<!-- Play Type Direct Delivery Plan Detail Modal -->
									<b-modal ref="DD-modal" size="xl" hide-footer title="View Plan Details">
										<div class="d-block text-left float-left">
											<!-- <b-button size="sm">Edit Plan</b-button> -->
											<!-- <router-link class="editgreybtn font-weight-bold d-inline-block"
												:to="{path:'/newPlanUpload', query:{planid:editplanid ? editplanid : upplanid,editflag:true}}">Edit
												Plan
											</router-link> -->
											<router-link class="editgreybtn font-weight-bold d-inline-block"
												:to="{path:'/newPlanUploadNew', query:{planid:editplanid ? editplanid : upplanid,editflag:true,delivery_location_without_plan:planSource}}">Edit
												Plan
											</router-link>
											<router-link v-if="!hidetimeflag" class="editgreybtn d-inline-block ml-5" :to="{path:''}">Total
												Loading time:
												{{totalloadtime}}Hrs
											</router-link>

											<!-- <b-button size="sm" class="ml-5 editgreybtn">Total Loading time: {{totalloadtime}}Hrs</b-button> -->
										</div>


										<div class="d-block float-right">
											<b>Total Records: </b> <b class="text-danger"> {{totalrecords}}</b>
										</div>
										<div class="clearfix"></div>
										<b-card-body class="p-0" style="overflow: auto;">
											<div class="table-responsive">
												<b-table class="mt-3" show-empty stacked="md" :busy="isBusy" :items="ddplandetaildata"
													:fields="ddplandetailfields" :current-page="currentPage" :per-page="perPage" :filter="filter"
													:sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection"
													@filtered="onFiltered" :bordered="bordered" :tbody-tr-class="rowClass">

													<div slot="table-busy" class="text-center text-danger my-2">
														<b-spinner class="align-middle"></b-spinner>
														<strong>Loading...</strong>
													</div>
													
													<template slot-scope="row">
														<span>{{ row.item.isactive == 1 ? 'active' : 'inactive' }}</span>
													</template>

													<template slot="planningorigin" slot-scope="row">
														<span>{{row.item.planningorigin || 'NA'}}</span>
													</template>

													<template slot="planningdate" slot-scope="row">
														<span>{{row.item.planningdate || 'NA'}}</span>
													</template>

													<template slot="loadid" slot-scope="row">
														<span>{{row.item.loadid || 'NA'}}</span>
													</template>

													<template slot="plandate" slot-scope="row">
														<span>{{row.item.planningdate || 'NA'}}</span>
													</template>

													<template slot="whorhub" slot-scope="row">
														<span>{{row.item.whorhub || 'NA'}}</span>
													</template>

													<template slot="noofboxes" slot-scope="row">
														<span>{{row.item.noofboxes || 'NA'}}</span>
													</template>

													<template slot="shippingreferenceno" slot-scope="row">
														<span>{{row.item.shippingreferenceno || 'NA'}}</span>
													</template>

													<template slot="userid" slot-scope="row">
														<span>{{row.item.userid || 'NA'}}</span>
													</template>

													<template slot="companyname" slot-scope="row">
														<span>{{row.item.companyname || 'NA'}}</span>
													</template>

													<template slot="dest_city" slot-scope="row">
														<span>{{row.item.dest_city || 'NA'}}</span>
													</template>

													<template slot="warehouseorhubname" slot-scope="row">
														<span>{{row.item.warehouseorhubname || 'NA'}}</span>
													</template>

													<template slot="loadpotype" slot-scope="row">
														<span>{{row.item.loadpotype || 'NA'}}</span>
													</template>

													<template slot="shipmentvolumetricweight" slot-scope="row">
														<span>{{row.item.shipmentvolumetricweight || 'NA'}}</span>
													</template>

													<template slot="shippincode" slot-scope="row">
														<span>{{row.item.shippincode || 'NA'}}</span>
													</template>
													<template slot="unloadingsequence" slot-scope="row">
														<span>{{row.item.unloadingsequence || 'NA'}}</span>
													</template>

													<template slot="vehicleno" slot-scope="row">
														<span class="href_vehicleNumber" @click="showVehicleDetails(row.item)" v-if="row.item.vehicleno!='NA'">{{row.item.vehicleno}}</span>
														<span v-else>NA</span>
													</template>
													<template slot="transportername" slot-scope="row">
														<span>{{row.item.transportername || 'NA'}}</span>
													</template>
													<template slot="isregularadhoc" slot-scope="row">
														<span>{{row.item.isregularadhoc || 'NA'}}</span>
													</template>
													<template slot="trip" slot-scope="row">
														<span>{{row.item.trip || 'NA'}}</span>
													</template>
													<template slot="remark" slot-scope="row">
														<span>{{row.item.remark || 'NA'}}</span>
													</template>
												</b-table>

											</div>
										</b-card-body>

										<!--show log data received -->
										<div class="mt-2" style="max-height: 300px; overflow: auto;">
											<h5>Log Data:</h5>
											<table>
												<thead>
													<tr>
														<th>Created By</th>
														<th>Created Date</th>
														<th>Update Date</th>
														<th>Update By</th>
														<th>Actions</th>
														<th>Comments</th>
													</tr>
												</thead>
												<tbody>
													<tr v-for="item in planLogData">
														<td>{{item.craetedby ? item.craetedby : ''}}</td>
														<td>{{item.createddate ? item.createddate : ''}}</td>
														<td>{{item.updatedat ? item.updatedat : ''}}</td>
														<td>{{item.updatedby ? item.updatedby : ''}}</td>
														<td style="text-align: left;">
															<span v-if="(item.addedload || item.removedload) && (!item.dailytriploadid)">
																Plan Edited
															</span>
															<span v-else>{{ item.planaction }}</span>
														</td>
														<td style="text-align: left;word-break: break-word;">
															<div v-if="item.dailytriploadid">
																<div>{{ item.plancomment }}</div>
															</div>
															<div v-else>
																<div><b>Load Added :</b> <span>{{item.addedload ? item.addedload :
																	''}}</span> </div>
															<div><b>Load Removed:</b><span>{{item.removedload ? item.removedload :
																	''}}</span> </div>
															</div>
															
														</td>
													</tr>

													<!-- <tr style="text-align: left;">
														<td style="text-align: left;">{{planLogData.craetedby ? planLogData.craetedby : ''}}</td>
														<td style="text-align: left;">{{planLogData.createddate ? planLogData.createddate : ''}}
														</td>
														<td style="text-align: left;">{{planLogData.updatedat ? planLogData.updatedat : ''}}</td>
														<td style="text-align: left;">{{planLogData.updatedby ? planLogData.updatedby : ''}}</td>

														<td style="text-align: left;">
															<span v-if="planLogData.addedload || planLogData.removedload">
																Plan Edited
															</span>
															<span v-else></span>
														</td>

														<td style="text-align: left;word-break: break-all;">
															<div><b>Load Added :</b> <span>{{planLogData.addedload ? planLogData.addedload :
																	''}}</span> </div>
															<div><b>Load Removed:</b><span>{{planLogData.removedload ? planLogData.removedload :
																	''}}</span> </div>
														</td>
													</tr> -->
												</tbody>
											</table>
										</div>


										<!-- <b-button class="mt-3" variant="outline-danger" block @click="hideModal">Close Me</b-button>
										<b-button class="mt-2" variant="outline-warning" block @click="toggleModal">Toggle Me</b-button> -->
									</b-modal>

									<!-- Plan Type Line Haul (LH) Plan Detail Modal -->
									<b-modal ref="LH-modal" size="xl" hide-footer title="Line Haul Details">
										<b-card-body class="p-0" style="overflow: auto;">
											<div class="table-responsive">

												<b-table class="mt-3" show-empty stacked="md" :busy="isBusy" :items="lhplandetaildata"
													:fields="dynamicFields" :current-page="currentPage" :per-page="perPage" :filter="filter"
													:sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection"
													@filtered="onFiltered" :bordered="bordered">

													<div slot="table-busy" class="text-center text-danger my-2">
														<b-spinner class="align-middle"></b-spinner>
														<strong>Loading...</strong>
													</div>

													<template slot="action" slot-scope="row">
														<!-- <b-button size="sm" class="mr-2" @click="edit(row)">
															<i class="fas fa-edit" aria-hidden="true"></i>
														</b-button> -->
														<router-link class="editwhitebtn font-weight-bold d-inline-block"
															:to="{path:'/newPlanUpload', query:{planid:editplanid,editflag:true}}"><i
																class="fas fa-edit" aria-hidden="true"></i>
														</router-link>
													</template>

													<template slot="vehicleplacementdate" slot-scope="row">
														<span>{{row.item.vehicleplacemantdate || 'NA'}}</span>
													</template>

													<template slot="vehicleno" slot-scope="row">
														<span class="href_vehicleNumber" @click="showVehicleDetails(row.item)" v-if="row.item.vehicleno!='NA'">{{row.item.vehicleno}}</span>
														<span v-else>NA</span>
													</template>

													<template slot="transportername" slot-scope="row">
														<span>{{row.item.transportername || 'NA'}}</span>
													</template>

													<template slot="origin" slot-scope="row">
														<span>{{row.item.originhubname || 'NA'}}</span>
													</template>

													<template slot="dispatchdatetime" slot-scope="row">
														<span>{{row.item.dispatchdate || 'NA'}}</span>
													</template>

													<!-- <template slot="destination1" slot-scope="row">
														<span>{{row.item.destination1 || 'NA'}}</span>
													</template>

													<template slot="dest1arrivaltime" slot-scope="row">
														<span>{{row.item.destarrivaldt1 || 'NA'}}</span>
													</template>

													<template slot="dest1departtime" slot-scope="row">
														<span>{{row.item.destdepartdt1 || 'NA'}}</span>
													</template>

													<template slot="destination2" slot-scope="row">
														<span>{{row.item.destination2 || 'NA'}}</span>
													</template>

													<template slot="dest2arrivaltime" slot-scope="row">
														<span>{{row.item.destarrivaldt2 || 'NA'}}</span>
													</template>

													<template slot="dest2departtime" slot-scope="row">
														<span>{{row.item.destdepartdt2 || 'NA'}}</span>
													</template>

													<template slot="destination3" slot-scope="row">
														<span>{{row.item.destination3 || 'NA'}}</span>
													</template>

													<template slot="dest3arrivaltime" slot-scope="row">
														<span>{{row.item.destarrivaldt3 || 'NA'}}</span>
													</template>

													<template slot="dest3departtime" slot-scope="row">
														<span>{{row.item.destdepartdt3 || 'NA'}}</span>
													</template> -->

													<template slot="download" slot-scope="row">

														<b-button size="sm" class="mr-2" @click="downloadAdhocFile(editplanid)">
															<i class="fas fa-download"></i>
														</b-button>


													</template>
												</b-table>
											</div>
										</b-card-body>
										<div class="d-block text-left mt-3">
											<!-- <b-button size="sm">Edit Plan</b-button> -->
											<div>
												<router-link class="editwhitebtn font-weight-bold d-inline-block"
													:to="{path:'/newPlanUpload', query:{planid:editplanid ? editplanid : upplanid,editflag:true}}">Edit
													Plan
												</router-link>
												<button class="editwhitebtn font-weight-bold d-inline-block ml-3"
													@click="showLHModal(editplanid,'hidehours')">View Plan
													Details
												</button>
											</div>

											<!-- <b-button size="sm" class="ml-5 editgreybtn">Total Loading time: {{totalloadtime}}Hrs</b-button> -->
										</div>


										<b-card-body class="p-0" style="overflow: auto;">
											<div class="table-responsive">

												<table id="planTable">
													<thead style="background: #ECEFF1 !important;">
														<tr id="headerRow">
															<th rowspan="2">Origin Hub</th>
															<th colspan="3" id="totalPlanLoadedHeader" class="text-center">Total Loads Planned</th>
															<!-- Dynamic columns under Total Plan Loaded -->
															<th rowspan="2">Total No. of Boxes</th>
															<th rowspan="2">Volumetric WT</th>
															<th rowspan="2">Physical WT</th>
															<th rowspan="2">Loads Dispatched</th>
															<th rowspan="2">Loads Hubinscan</th>
															<th rowspan="2">Damage Box</th>
															<th rowspan="2">Shortage</th>
															<th rowspan="2">Excess</th>
															<th rowspan="2">Vehicle Release Time</th>
														</tr>
														<tr id="hubloadHeaderRow">
															<!-- Dynamic hubload keys will go here -->
															<th>Total</th>
														</tr>
													</thead>
													<tbody id="planData">
														<!-- Data rows will be appended here -->
													</tbody>
													<tfoot id="totalRow">
														<!-- Total row will be appended here -->
													</tfoot>
												</table>
											</div>
										</b-card-body>


										<b-card-body class="p-0" style="overflow: auto;">
											<div class="table-responsive">

												<b-table class="mt-3" show-empty stacked="md" :busy="isBusy" :items="lhhubloadunload"
													:fields="hubzone" :current-page="currentPage" :per-page="perPage" :filter="filter"
													:sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection"
													@filtered="onFiltered" :bordered="bordered">

													<div slot="table-busy" class="text-center text-danger my-2">
														<b-spinner class="align-middle"></b-spinner>
														<strong>Loading...</strong>
													</div>

													<template slot="hubname" slot-scope="row">
														<span>{{row.item.hubname || 'NA'}}</span>
													</template>

													<template slot="loadingtime" slot-scope="row">
														<span v-if="row.item.loadingtime">{{row.item.loadingtime}} hrs</span>
														<span v-else>NA</span>
													</template>

													<template slot="unloadingtime" slot-scope="row">
														<span v-if="row.item.unloadingtime">{{row.item.unloadingtime}} hrs</span>
														<span v-else>NA</span>
													</template>

													<template slot="zoningtime" slot-scope="row">
														<span v-if="row.item.zoningtime">{{row.item.zoningtime}} hrs</span>
														<span v-else>NA</span>
													</template>
												</b-table>
											</div>
										</b-card-body>
									</b-modal>
								</div>
							</b-tab>


							<b-tab title="Regular Vehicle Plan" title-item-class="tabbutton" class="tabbutton text-center"
								@click="activeTab = 0">
								<div class="container1">
									<form>
										<div class="form-row1">
											<div class="form-group1">
												<b-form-select v-model="selected_warehouse" class="ml-2">
													<option value="">Select Warehouse</option>
													<option :value="hub.hubid" v-for="hub in optionsWH" :key="hub.hubid">{{hub.hubname}} -
														{{hub.hubid}}</option>
												</b-form-select>
											</div>

											<div class="form-group1">
												<label class="mb-1 mr-2  font-weight-bold" for="calendar1">Planning From Date:</label>
												<v-date-picker class="custom-date-picker" :available-dates='{ start: null, end: new Date() }'
													v-model='selectDateFrom'>
												</v-date-picker>
											</div>

											<div class="form-group1">
												<label class="ml-2 mb-1 font-weight-bold" for="calendar2">Planning To Date:</label>
												<v-date-picker class="custom-date-picker" :available-dates='{ start: null, end: new Date() }'
													v-model='selectDateTo'>
												</v-date-picker>
											</div>

											<div class="form-group1">
												<b-form-select v-model="planstatus" class="ml-3">
													<option value="">Plan Status</option>
													<option value="open">Open</option>
													<option value="close">Close</option>
												</b-form-select>
											</div>

											<div class="form-group1 ml-1">
												<b-form-select v-model="plantype" class="ml-1">
													<option value="">Plan Type</option>
													<option value="DD">Direct Delivery(DD)</option>
													<option value="LH">Line Haul(LH)</option>
													<option value="NLH">National Line Haul(NLH)</option>
												</b-form-select>
											</div>

											<div class="form-group1  ml-0">
												<label class="" for="textInput"><b>Total Records :</b></label>
												<div class="mt-2">
													<b>
														<p> <span style="color:red;  font-size: 12px"> {{totalRecord}}</span></p>
													</b>
												</div>
											</div>
										</div>
									</form>
								</div>
								<b-row>
									<b-col class="mb-3 mt-3">
										<b-button class="custom-green-button btn-black" variant="success"
											@click="applySearch()">Search</b-button>
										<b-button variant="danger" class="ml-2 btn-black" @click="clearFilter()">Clear</b-button>
										<b-button class="ml-2 btn-black" @click="downloadConsolidateCsv()">Download Consolidate Excel
											File<a :href=conslidateUrl></a>
										</b-button>
										<!-- </a> -->
									</b-col>
								</b-row>
								<div class="accordion" role="tablist">
									<b-card no-body class="mb-1" v-for="(locations, location) in plandata" :key="location">
										<b-card-header header-tag="header" class="p-1" role="tab">
											<b-button block v-b-toggle="'accordion-1' + location" class="text-left">
												{{ location.charAt(0).toUpperCase() + location.slice(1) }}
												<!-- <span style="cursor: pointer;" @click="toggleCollapse(location)">
													<i :class="isOpen(location) ?  'fas fa-plus' : 'fas fa-minus'"></i>
												</span> -->
											</b-button>
										</b-card-header>
										<b-collapse :id="'accordion-1' + location" :visible="isOpen(location)">
											<!-- style="overflow:auto;" role="tabpanel"  accordion="my-accordion"  -->
											<b-card-body class="p-0" style="overflow: auto;">
												<div class="table-responsive">
													<b-table class="m-0" show-empty stacked="md" :busy="isBusy" :items="locations"
														:fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter"
														:sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection"
														@filtered="onFiltered" :bordered="bordered">

														<div slot="table-busy" class="text-center text-danger my-2">
															<b-spinner class="align-middle"></b-spinner>
															<strong>Loading...</strong>
														</div>

														<template slot="srno" slot-scope="row">
															<span>{{row.index + 1}}</span>
														</template>

														<template slot="planid" slot-scope="row">
															<span>{{row.item.planid}}</span>
														</template>

														<template slot="vehicleno" slot-scope="row">
															<span class="href_vehicleNumber" @click="showVehicleDetails(row.item)" v-if="row.item.vehicleno!='NA'">{{row.item.vehicleno}}</span>
															<span v-else>NA</span>
														</template>

														<template slot="vendorname" slot-scope="row">
															<span>{{row.item.vendorname ? row.item.vendorname.charAt(0).toUpperCase() +
																row.item.vendorname.slice(1) : row.item.vendorname}}</span>
														</template>

														<template slot="plandate" slot-scope="row">
															<span>{{row.item.plandate}}</span>
														</template>

														<template slot="route" slot-scope="row">
															<span>{{row.item.route ? row.item.route.charAt(0).toUpperCase() + row.item.route.slice(1):
																row.item.route}}</span>
														</template>

														<template slot="valweight" slot-scope="row">
															<span>{{row.item.valweight}}</span>
														</template>

														<template slot="plantype" slot-scope="row">
															<span>{{row.item.plantype ? row.item.plantype.charAt(0).toUpperCase() +
																row.item.plantype.slice(1) : row.item.plantype}}</span>
														</template>

														<template slot="plantatus" slot-scope="row">
															<span>{{row.item.plantatus ? row.item.plantatus.charAt(0).toUpperCase() +
																row.item.plantatus.slice(1): row.item.plantatus}}</span>
														</template>

														<template slot="destination" slot-scope="row">
															<span>{{row.item.destination.join(', ') }}</span>
														</template>

														<template slot="destinationPoints" slot-scope="row">
															<span>{{row.item.destination.length}}</span>
														</template>

														<template slot="loadcount" slot-scope="row">
															<span>{{row.item.loadcount}}</span>
														</template>

														<template slot="boxcount" slot-scope="row">
															<span>{{row.item.boxcount}}</span>
														</template>

														<template slot="tripid" slot-scope="row">
															<span>{{row.item.tripid}}</span>
														</template>

														<template slot="currentloc" slot-scope="row">
															<span>{{row.item.currentloc ? row.item.currentloc.charAt(0).toUpperCase() +
																row.item.currentloc.slice(1) : row.item.currentloc}}</span>
														</template>
														<template slot="distancecovered" slot-scope="row">
															<span>{{row.item.distancecovered}}</span>
														</template>

														<template slot="downloadfile" slot-scope="row">
															<!-- <a :href="adhocPlanCsvUrl"> -->
															<b-button size="sm" class="mr-2" @click="downloadAdhocFile(row.item.planid)">
																<i class="fas fa-download"></i>
															</b-button>
															<!-- </a> -->
														</template>

														<template slot="action" slot-scope="row">
															<b-button size="sm" class="mr-2" @click="showModal(row)">
																<i class="fas fa-edit" aria-hidden="true"></i>
															</b-button>
														</template>

													</b-table>
												</div>
											</b-card-body>
										</b-collapse>
									</b-card>

								</div>

							</b-tab>
						</b-tabs>
					</div>
					<b-modal size="md" title="Vehicle Details" v-model="vehicleDetailsModal" hide-footer>
						<b-row>
						<div id="listloader" v-if="loader">
						<div class="listloader"></div>
						</div>
						<b-col sm="12" class="mt-2">Driver First Name : {{vehicleDetails.length?vehicleDetails[0].driverfirstname:'-'}}</b-col>
						<b-col sm="12" class="mt-2">Driver Last Name : {{vehicleDetails.length?vehicleDetails[0].driverlastname:'-'}}</b-col>
						<b-col sm="12" class="mt-2">Mobile Number : {{vehicleDetails.length?vehicleDetails[0].drivermobilenumber:'-'}}</b-col>
						<b-col sm="12" class="mt-2">Vehicle Number : {{vehicleDetails.length?vehicleDetails[0].vehicle_no:'-'}}</b-col>
						<b-col sm="12" class="mt-2">Hub City Name : {{vehicleDetails.length?vehicleDetails[0].hub_city:'-'}}</b-col>
						<b-col sm="12" class="mt-2">Vehicle Type : {{vehicleDetails.length?vehicleDetails[0].vehicle_type:'-'}}</b-col>
						<b-col sm="12" class="mt-2">Transporter Company Name : {{vehicleDetails.length?vehicleDetails[0].transporter_company_name:'-'}}</b-col>
						<b-col class="mt-3 text-right">
						<b-button variant="outline-dark" @click="redirectTovehiclePage(vehicleDetails.length?vehicleDetails[0]:'')">View Complete Info</b-button>
						</b-col>
						</b-row>
					</b-modal>
				</b-card>
			</b-col>
		</b-row>
	</div>
</template>
<script>
	import CONSTANTS from "@/utils/constants";
	import Vue from "vue";
	import { EventBus } from "./event-bus.js";
	import Utils from "@/utils";
	import auth from "@/utils/auth";
	export default {
		props: {
			logData: {
				type: Object,
				required: true,
			},
		},
		data: function () {
			return {
				collapsed: {},
				activeTab: 1,
				selectedOption: null, // Initial selected value
				isBusy: false,
				planUploadedType: null,
				hub_name: "",
				selected_vehicleno: "",
				selectcsvFile: "",
				selectFiletype: "",
				file: "",
				selectDateFrom: '',
				selectDateTo: '',
				vehiclenumber: [],
				csvUrl: "",
				csvUrlvar: "",
				totalRecord: '',
				options: [{
					text: "Hub Inward",
					value: "Hub Inward"
				}, {
					text: "Hub Inward And Direct Dispatch Plan",
					value: "Hub Inward And Direct Dispatch Plan",
				}, {
					text: "Direct Dispatch And Hub Inward Plan",
					value: "Direct Dispatch And Hub Inward Plan",
				}, {
					text: "Hub Outward",
					value: "Hub Outward"
				}, {
					text: "Hub Outward And Direct Dispatch Plan",
					value: "Hub Outward And Direct Dispatch Plan",
				}, {
					text: "Direct Dispatch Plan",
					value: "Direct Dispatch Plan"
				}, {
					text: "Client Pickup",
					value: "Client Pickup"
				}],
				items: [],
				openedLocations: [],
				fields: [{
					key: "srno",
					label: "Sr. no",
					sortable: true,
					sortDirection: "desc",
				},{
					key: "planid",
					label: "Plan ID",
					sortable: true,
					sortDirection: "desc",
				}, {
					key: "vehicleno",
					label: "Vehicle number ",
					sortable: true,
					sortDirection: "desc",
				}, {
					key: "vendorname",
					label: "Vendor name",
					sortable: true,
					sortDirection: "desc",
				}, {
					key: "plandate",
					label: "Planning date",
					sortable: true,
					sortDirection: "desc",
				}, {
					key: "route",
					label: "Route",
					sortable: true,
					sortDirection: "desc",
				},
				{
					key: "valweight",
					label: "Volumetric WT",
					sortable: true,
					sortDirection: "desc",
				},
				{
					key: "plantype",
					label: "Plan Type",
					sortable: true,
					sortDirection: "desc",
				}, {
					key: "planstatus",
					label: "Plan Status",
					sortable: true,
					sortDirection: "desc",
				}, {
					key: "destination",
					label: "Destination",
					sortable: true,
					sortDirection: "desc",
				}, {
					key: "destinationPoints",
					label: "Destination Points",
					sortable: true,
					sortDirection: "desc",
				}, {
					key: "loadcount",
					label: "Load Count",
					sortable: true,
					sortDirection: "desc",
				}, {
					key: "boxcount",
					label: "Box Count",
					sortable: true,
					sortDirection: "desc",
				}, {
					key: "tripid",
					label: "Trip ID",
					sortable: true,
					sortDirection: "desc",
				},
				{
					key: "currentloc",
					label: "Current Location",
					sortable: true,
					sortDirection: "desc",
				},
				{
					key: "distancecovered",
					label: "Distance Covered",
					sortable: true,
					sortDirection: "desc",
				},
				{
					key: "planuploadedby",
					label: "Plan Uploaded by",
					sortable: true,
					sortDirection: "desc",
				},
				{
					key: "downloadfile",
					label: "Download File",
					sortable: true,
					sortDirection: "desc",
				},
				{
					key: "action",
					label: "Action",
					sortable: true,
					sortDirection: "desc",
				}],

				ddplandetailfields: [{
					key: "planningorigin",
					label: "Planning Origin",
					sortable: true,
					sortDirection: "desc",
				}, {
					key: "planningdate",
					label: "Planning Date",
					sortable: true,
					sortDirection: "desc",
				}, {
					key: "loadid",
					label: "Load ID",
					sortable: true,
					sortDirection: "desc",
				}, {
					key: "whorhub",
					label: "WH/HUB",
					sortable: true,
					sortDirection: "desc",
				}, {
					key: "noofboxes",
					label: "No. Of Boxes",
					sortable: true,
					sortDirection: "desc",
				},
				{
					key: "shippingreferenceno",
					label: "Shipping Ref. No.",
					sortable: true,
					sortDirection: "desc",
				},
				{
					key: "userid",
					label: "User ID",
					sortable: true,
					sortDirection: "desc",
				}, {
					key: "companyname",
					label: "Company Name",
					sortable: true,
					sortDirection: "desc",
				}, {
					key: "dest_city",
					label: "Dest_City",
					sortable: true,
					sortDirection: "desc",
				}, {
					key: "warehouseorhubname",
					label: "warehousename / Hub zone",
					sortable: true,
					sortDirection: "desc",
				}, {
					key: "loadpotype",
					label: "loadpotype",
					sortable: true,
					sortDirection: "desc",
				}, {
					key: "shipmentvolumetricweight",
					label: "shipmentvolumetric weight",
					sortable: true,
					sortDirection: "desc",
				}, {
					key: "shippincode",
					label: "shippincode",
					sortable: true,
					sortDirection: "desc",
				},
				{
					key: "unloadingsequence",
					label: "unloading sequence",
					sortable: true,
					sortDirection: "desc",
				},
				{
					key: "vehicleno",
					label: "vehicleno",
					sortable: true,
					sortDirection: "desc",
				},
				{
					key: "transportername",
					label: "transporter name",
					sortable: true,
					sortDirection: "desc",
				},
				{
					key: "isregularadhoc",
					label: "isregularadhoc",
					sortable: true,
					sortDirection: "desc",
				},
				{
					key: "trip",
					label: "trip",
					sortable: true,
					sortDirection: "desc",
				},
				{
					key: "remark",
					label: "remark",
					sortable: true,
					sortDirection: "desc",
				}
				],

				// linehaul: [{
				// 	key: "action",
				// 	label: "Action",
				// 	sortable: true,
				// 	sortDirection: "desc",
				// }, {
				// 	key: "vehicleplacementdate",
				// 	label: "Vehicle Placement Date",
				// 	sortable: true,
				// 	sortDirection: "desc",
				// }, {
				// 	key: "vehicleno",
				// 	label: "Vehicle number ",
				// 	sortable: true,
				// 	sortDirection: "desc",
				// }, {
				// 	key: "transportername",
				// 	label: "Transporter Name",
				// 	sortable: true,
				// 	sortDirection: "desc",
				// }, {
				// 	key: "origin",
				// 	label: "Origin",
				// 	sortable: true,
				// 	sortDirection: "desc",
				// },
				// {
				// 	key: "dispatchdatetime",
				// 	label: "Dispatch date-time",
				// 	sortable: true,
				// 	sortDirection: "desc",
				// },
				// {
				// 	key: "destination1",
				// 	label: "Destination1",
				// 	sortable: true,
				// 	sortDirection: "desc",
				// },
				// {
				// 	key: "dest1arrivaltime",
				// 	label: "Destination1 Arrival Date-time",
				// 	sortable: true,
				// 	sortDirection: "desc",
				// },
				// {
				// 	key: "dest1departtime",
				// 	label: "Destination1 departure Date-time",
				// 	sortable: true,
				// 	sortDirection: "desc",
				// },
				// {
				// 	key: "destination2",
				// 	label: "Destination2",
				// 	sortable: true,
				// 	sortDirection: "desc",
				// },
				// {
				// 	key: "dest2arrivaltime",
				// 	label: "Destination2 Arrival Date-time",
				// 	sortable: true,
				// 	sortDirection: "desc",
				// },
				// {
				// 	key: "dest2departtime",
				// 	label: "Destination2 departure Date-time",
				// 	sortable: true,
				// 	sortDirection: "desc",
				// },
				// {
				// 	key: "destination3",
				// 	label: "Destination3",
				// 	sortable: true,
				// 	sortDirection: "desc",
				// },
				// {
				// 	key: "dest3arrivaltime",
				// 	label: "Destination3 Arrival Date-time",
				// 	sortable: true,
				// 	sortDirection: "desc",
				// },
				// {
				// 	key: "dest3departtime",
				// 	label: "Destination3 departure Date-time",
				// 	sortable: true,
				// 	sortDirection: "desc",
				// },
				// {
				// 	key: "download",
				// 	label: "Download",
				// 	sortable: true,
				// 	sortDirection: "desc",
				// }],

				linehaul: [
					{ key: "action", label: "Action", sortable: true },
					{ key: "vehicleplacementdate", label: "Vehicle Placement Date", sortable: true },
					{ key: "vehicleno", label: "Vehicle number ", sortable: true },
					{ key: "transportername", label: "Transporter Name", sortable: true },
					{ key: "origin", label: "Origin", sortable: true },
					{ key: "dispatchdatetime", label: "Dispatch date-time", sortable: true },
					// We will insert dynamic fields after this
					{ key: "download", label: "Download", sortable: true }
				],

				dynamicFields: [],


				hubzone: [{
					key: "hubname",
					label: "Hub Name",
					sortable: true,
					sortDirection: "desc",
				}, {
					key: "loadingtime",
					label: "Loading Time",
					sortable: true,
					sortDirection: "desc",
				}, {
					key: "unloadingtime",
					label: "Unloading Time",
					sortable: true,
					sortDirection: "desc",
				}, {
					key: "zoningtime",
					label: "Zoning time",
					sortable: true,
					sortDirection: "desc",
				}],

				hubzonedetail: [{
					key: "originhub",
					label: "Origin Hub",
					sortable: true,
					sortDirection: "desc",
				}, {
					key: "totalloadsplanned",
					label: "Total Loads Planned",
					sortable: true,
					sortDirection: "desc",
				}, {
					key: "totalboxes",
					label: "Total No. of Boxes",
					sortable: true,
					sortDirection: "desc",
				}, {
					key: "volumetricwt",
					label: "Volumetric WT",
					sortable: true,
					sortDirection: "desc",
				}, {
					key: "physicalwt",
					label: "Physical WT",
					sortable: true,
					sortDirection: "desc",
				},
				{
					key: "loadsdispatched",
					label: "Loads Dispatched",
					sortable: true,
					sortDirection: "desc",
				},
				{
					key: "loadshubinscan",
					label: "Loads Hubinscan",
					sortable: true,
					sortDirection: "desc",
				},
				{
					key: "vehiclereleasetime",
					label: "Vehicle Release Time",
					sortable: true,
					sortDirection: "desc",
				},
				{
					key: "damagebox",
					label: "Damage Box",
					sortable: true,
					sortDirection: "desc",
				},
				{
					key: "shortage",
					label: "shortage",
					sortable: true,
					sortDirection: "desc",
				},
				{
					key: "excess",
					label: "excess",
					sortable: true,
					sortDirection: "desc",
				}
				],

				selected_vehicleno: '',
				file: '',
				accessBody: [],
				isReadOnly: false,
				optionsWH: [],
				WHData: [],
				selected_warehouse: '',
				planstatus: '',
				plantype: '',
				filters: {},
				adhocPlanCsvUrl: '',
				editplanid: '',
				totalloadtime: '',
				totalrecords: '',
				ddplandetaildata: [],
				lhplandetaildata: [],
				lhhubloadunload: [],
				planIds: [],
				conslidateUrl: '',
				lhhubdetails: [],
				plandetaildata: [],
				planLogData: '',
				showUpdatedPlanLog: false,
				useremailid: '',
				currentDate: '',
				hidetimeflag: false,
				upplanid: '',
				plandata: {},
				vehicleDetailsModal:false,
				vehicleDetails:[],
				loader:false,
			};

		},

		// components: {
		// 	newplanAdd
		// },


		created: function () {
			var userdata = localStorage.getItem("userData");
			var userInfo = JSON.parse(userdata);
			this.userType = userInfo.user_type;
			this.useremailid = userInfo.sysemailid;
			this.user_id = userInfo.sysusermasterid;
			this.hub_id = userInfo.hub_id ? userInfo.hub_id : ''
			this.user_type = userInfo.user_type ? userInfo.user_type : ''
			this.accessBody = userInfo.body;
			this.plandata= {}


			//receiving plan id from new plan upload
			// if (this.$route.query && this.$route.query.planid) {
			// this.showLHModal(this.$route.query.planid)
			// this.showUpdatedPlanLog = true
			// this.planLogData = this.$route.query.logData ? this.$route.query.logData : null;
			// }

			if (this.$route.query && this.$route.query.planid) {
			    this.showLHModal(this.$route.query.planid)
			}

			this.ischeckbodyvalidation();
			this.getAllPlanListing();
			this.vehicleListing();
			this.showWHlist();
			this.applySearch();

			this.currentDate = new Date().toLocaleString('en-US', {
				weekday: 'short',
				month: 'short',
				day: 'numeric',
				year: 'numeric',
				hour: 'numeric',
				minute: 'numeric',
				hour12: true,
			}).replace(',', ''); // Remove comma


			// Retrieve and parse the log data from the query
			// this.planLogData = ''
			// this.planLogData = this.$route.query.logData ? this.$route.query.logData : null;
			// console.log("Received data:", this.planLogData);
			// if (this.planLogData && this.planLogData.planid) {
			// 	this.getAllPlanListing();
			// 	this.showUpdatedPlanLog = true
			// 	this.upplanid = this.planLogData.planid
			// 	this.showLHModal(this.planLogData.planid)
			// 	this.currentDate = new Date().toLocaleString('en-US', {
			// 		weekday: 'short',
			// 		month: 'short',
			// 		day: 'numeric',
			// 		year: 'numeric',
			// 		hour: 'numeric',
			// 		minute: 'numeric',
			// 		hour12: true,
			// 	}).replace(',', ''); // Remove comma
			// } else {
			// 	this.showUpdatedPlanLog = false
			// }
		},
		computed: {
			apiUrl() {
				return this.planUploadedType == 'Hub Inward' ? `${CONSTANTS.MISREPORT_API_URL}/uploadHubInwardPlan` : this.planUploadedType == 'Hub Inward And Direct Dispatch Plan' ? `${CONSTANTS.MISREPORT_API_URL}/uploadHubInwardAndDirectDispatch` : this.planUploadedType == 'Direct Dispatch And Hub Inward Plan' ? `${CONSTANTS.MISREPORT_API_URL}/uploadDirectDispatchAndHubInward` : this.planUploadedType == 'Hub Outward' ? `${CONSTANTS.MISREPORT_API_URL}/uploadHubOutwardPlan` : this.planUploadedType == 'Hub Outward And Direct Dispatch Plan' ? `${CONSTANTS.MISREPORT_API_URL}/uploadHubOutwardAndDirectDispatchPlan` : `${CONSTANTS.MISREPORT_API_URL}/uploadDirectDispatchPlan`;

			},
		},

		mounted() {
		},

		watch: {
			activeTab() {
				this.selected_warehouse = ''
				this.selectDateFrom = ''
				this.selectDateTo = ''
				this.planstatus = ''
				this.plantype = ''
				this.plandata= {}
				this.applySearch();
			},

			// lhplandetaildata: 'updateDynamicFields'
			lhplandetaildata: {
				handler: 'updateDynamicFields',
				immediate: true
			}
		},
		methods: {
			showVehicleDetails(value){
				this.vehicleDetails = []
				this.loader=true;
				this.vehicleDetailsModal =! this.vehicleDetailsModal;

				if (this.vehicleDetailsModal) {
				const obj = {
				vehicle_id : value.vehicle_id
				}

				this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getVehicleDetailsForDriverDetails`,obj)
				.then(result=>{
				this.loader=false;
				if(result.body.returnmsg === "Successful"){
				this.vehicleDetails = result.body.returnvalue;
				}
				else{
				this.vehicleDetails = []
				}
				}) 
				}
			},

			redirectTovehiclePage(value) {
            let url = null;

            if (value.vehicle_type === 'intra' || value.vehicle_type === 'inter') {
                url = this.$router.resolve({
                    path: "/vehicleMaster",
                    query: { vehicleDetails: JSON.stringify(this.vehicleDetails[0]), HideAnyAction: 'Yes' }
                }).href;
            } 
            else if (
                (value.vehicle_type === 'adhoc' || value.vehicle_type === 'Adhoc') &&
                (value.approver_status === "Pending" || value.approver_status === "pending") &&
                (value.vehicleregistrationcompleted !== 'No' && value.vehicleregistrationcompleted !== 'NO')
            ) {
                url = this.$router.resolve({
                    path: "/vehicleMaster",
                    query: { vehicleDetails: JSON.stringify(this.vehicleDetails[0]), HideAnyAction: 'Yes' }
                }).href;
            } 
            else if (
                (value.vehicle_type === 'adhoc' || value.vehicle_type === 'Adhoc') &&
                (value.approver_status === "Pending" || value.approver_status === "pending") &&
                (value.vehicleregistrationcompleted === 'No' || value.vehicleregistrationcompleted === 'NO')
            ) {
                url = this.$router.resolve({
                    path: "/adhocVehicle",
                    query: { vehicleDetails: JSON.stringify(this.vehicleDetails[0]), HideAnyAction: 'Yes' }
                }).href;
            } 
            else if (
                (value.vehicle_type === 'adhoc' || value.vehicle_type === 'Adhoc') &&
                ["approved", "freight_pending", "rejected"].includes(value.approver_status)
            ) {
                url = this.$router.resolve({
                    path: "/adhocVehicle",
                    query: { vehicleDetails: JSON.stringify(this.vehicleDetails[0]), HideAnyAction: 'Yes' }
                }).href;
            }

            // Open URL if it's set
            if (url) {
                window.open(url, "_blank");
            }
        },
			handleUpdateData(data) {
				console.log("event received data", data)
			},

			//line haul detail popup detail second dynamic table
			getplandetaildata(data) {

				// Get table elements
				const tableBody = document.getElementById('planData');
				const hubloadHeaderRow = document.getElementById('hubloadHeaderRow');
				const totalPlanLoadedHeader = document.getElementById('totalPlanLoadedHeader');
				const totalRow = document.getElementById('totalRow');

				// Collect all unique hubload keys across all items in plandetaildata
				const uniqueHubloadKeys = [...new Set(this.plandetaildata.flatMap(item => item.hubload.map(hub => hub.key)))];

				// Dynamically generate hubload columns based on all unique keys
				uniqueHubloadKeys.forEach(key => {
					const th = document.createElement('th');
					th.textContent = key;
					hubloadHeaderRow.insertBefore(th, hubloadHeaderRow.querySelector('th:last-child'));
				});

				// Adjust the colspan of the "Total Plan Loaded" header
				totalPlanLoadedHeader.setAttribute('colspan', uniqueHubloadKeys.length + 1); // hubload columns + "Total" column

				data.forEach(item => {
					const row = document.createElement('tr');

					// Create cells for each column
					const originhubCell = document.createElement('td');
					originhubCell.textContent = item.hubname;
					row.appendChild(originhubCell);

					// Create cells for hubload dynamically under Total Plan Loaded
					uniqueHubloadKeys.forEach(key => {
						const hubCell = document.createElement('td');
						const hubData = item.hubload.find(hub => hub.key === key);
						// hubCell.textContent = hubData ? hubData.value : '-'; // If no matching hubload key, show '-'
						if(hubData && hubData.value){
							if(hubData.value == 0){
								hubCell.textContent = ''
							}else{
								hubCell.textContent = hubData.value
							}
						}
						row.appendChild(hubCell);
					});

					// Add Total column under "Total Plan Loaded"
					const totalCell = document.createElement('td');
					totalCell.textContent = item.total;
					row.appendChild(totalCell);

					// Other static columns
					const noofboxesCell = document.createElement('td');
					noofboxesCell.textContent = item.noofboxes;
					row.appendChild(noofboxesCell);

					const valweightCell = document.createElement('td');
					valweightCell.textContent = item.valweight;
					row.appendChild(valweightCell);

					const physicalweightCell = document.createElement('td');
					physicalweightCell.textContent = item.physicalweight;
					row.appendChild(physicalweightCell);

					const dispatchscanCell = document.createElement('td');
					dispatchscanCell.textContent = item.dispatchscan;
					row.appendChild(dispatchscanCell);

					const hubscanCell = document.createElement('td');
					hubscanCell.textContent = item.hubscan;
					row.appendChild(hubscanCell);

					const damageboxCell = document.createElement('td');
					damageboxCell.textContent = item.damagebox;
					row.appendChild(damageboxCell);

					const shortageCell = document.createElement('td');
					shortageCell.textContent = item.shortage;
					row.appendChild(shortageCell);

					const excessCell = document.createElement('td');
					excessCell.textContent = item.excess;
					row.appendChild(excessCell);

					const vreleasetimeCell = document.createElement('td');
					vreleasetimeCell.textContent = item.vreleasetime + ' hrs';
					row.appendChild(vreleasetimeCell);

					// Append row to table body
					tableBody.appendChild(row);
				});

				const totalRowData = {};
				totalRowData.noofboxes = "";
				totalRowData.total = 0; // Total for the 'total' column

				// Initialize hubload totals for each unique key
				uniqueHubloadKeys.forEach(key => {
					totalRowData[key] = 0; // Initialize total for hubload
				});

				// Calculate totals
				data.forEach(item => {
					totalRowData.total += item.total; // Sum up total values
					// totalRowData.noofboxes += item.noofboxes; // Sum up noofboxes

					// Sum up hubload values
					item.hubload.forEach(hub => {
						totalRowData[hub.key] = (totalRowData[hub.key] || 0) + hub.value;
					});
				});

				// Create the total row for total values
				const totalRowElement = document.createElement('tr');
				totalRowElement.classList.add('total-row');

				// Label for the total row
				const totalLabelCell = document.createElement('td');
				totalLabelCell.textContent = 'Total';
				totalRowElement.appendChild(totalLabelCell);

				// Append hubload total cells
				uniqueHubloadKeys.forEach(key => {
					const hubTotalCell = document.createElement('td');
					hubTotalCell.textContent = totalRowData[key] || '-'; // If no total, show '-'
					totalRowElement.appendChild(hubTotalCell);
				});

				// Add the total of 'total' column
				const totalTotalCell = document.createElement('td');
				totalTotalCell.textContent = totalRowData.total; // Total of total values
				totalRowElement.appendChild(totalTotalCell);

				// Add total for noofboxes to the same total row
				const totalNoOfBoxesCell = document.createElement('td');
				totalNoOfBoxesCell.textContent = totalRowData.noofboxes; // Total of noofboxes
				totalRowElement.appendChild(totalNoOfBoxesCell);

				// Leave other cells empty
				for (let i = 0; i < 8; i++) { // 8 is the number of static columns (Val Weight to V Release Time)
					const emptyCell = document.createElement('td');
					totalRowElement.appendChild(emptyCell);
				}

				// Append the total row to the table footer
				totalRow.appendChild(totalRowElement);
			},


			// dynamic first table of line haul detail pop up
			updateDynamicFields() {
				// Clear dynamic fields first
				const dynamicCols = [];

				// Get the total destination count from the first item in the array
				const totalDestCount = this.lhplandetaildata.length > 0
					? this.lhplandetaildata[0].totaldest : 0;

				// Generate dynamic columns based on the total destination count
				for (let i = 1; i <= totalDestCount; i++) {
					dynamicCols.push(
						{ key: `destination${i}`, label: `Destination${i}`, sortable: true },
						{ key: `destarrivaldt${i}`, label: `Destination${i} Arrival Date-time`, sortable: true },
						{ key: `destdepartdt${i}`, label: `Destination${i} Departure Date-time`, sortable: true }
					);
				}

				// Find index of the dispatchdatetime column
				const dispatchIndex = this.linehaul.findIndex(field => field.key === 'dispatchdatetime');

				// Insert dynamic fields after dispatchdatetime
				if (dispatchIndex !== -1) {
					this.dynamicFields = [
						...this.linehaul.slice(0, dispatchIndex + 1), // Fields before and including dispatchdatetime
						...dynamicCols, // Add dynamic fields
						...this.linehaul.slice(dispatchIndex + 1) // Fields after dispatchdatetime
					];
				} else {
					this.dynamicFields = [...this.linehaul, ...dynamicCols]; // Fallback if not found
				}
			},


			ischeckbodyvalidation() {
				for (let i = 0; i < this.accessBody.length; i++) {
					const element = this.accessBody[i];

					// if (element.title=='Bulk Reallocation' && element.isReadonly==true && this.route_id=='normal') {
					//   this.isReadOnly=true
					// }
					if (element.child) {
						for (let j = 0; j < element.child.length; j++) {
							const k = element.child[j];
							if (k.title == 'Bulk Reallocation' && k.isReadonly == true) {
								this.isReadOnly = true
							}
						}
					}
				}
			},
			// warehouse list
			showWHlist: function () {

				var userdata = localStorage.getItem('userData')
				var userInfo = JSON.parse(userdata)

				const obj = {
					sysusermasterid: `${userInfo.sysusermasterid}`,
					usertype: `${userInfo.user_type}`,
				}

				this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getAllHubListing`, obj)
					.then(result => {
						if (result.body.returnmsg === 'Successful') {
							this.optionsWH = result.body.returnvalue;
						} else {
							this.optionsWH = []
						}

					})
					.catch(ex => {
						console.log("error-----", ex);
					});
			},

			vehicleListing() {
				var userdata = localStorage.getItem("userData");
				var userInfo = JSON.parse(userdata);
				let obj = {
					sysusermasterid: `${userInfo.sysusermasterid}`,
					usertype: "",
					isactive: "1",
					vehicle_type: "bulkreallocate",
				};
				this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getVehicleListing`, obj).then((result) => {
					this.vehicleitems = result.body;
					for (let i = 0; i < this.vehicleitems.length; i++) {
						this.vehiclenumber.push(this.vehicleitems[i].vehicle_no);
					}
				}).catch((ex) => {
					console.log("error", ex);
				});
			},

			downloadplanedcsv() {

				this.csvUrl = `${CONSTANTS.MIGRATION_API_URL}/getSampleCSVForPlanType?plan_type=`
				this.csvUrlvar = this.csvUrl;
				console.log(this.csvUrlvar);
			},

			validateForm(scope) {
				this.$validator.validateAll(scope).then((result) => {
					if (result) {
						this.uploadPalnDetails();
					}
				});
			},

			selectcsvFiletoUpload(event) {
				this.selectcsvFile = event.target.files[0];
				// this.imgname= this.selectedFiles.name;
				// console.log("HHH", this.selectcsvFile);
				this.selectFiletype = event.target.files[0].type;
				console.log("selectFiletype", this.selectFiletype);
			},

			uploadPalnDetails: function () {
				document.getElementById("overlay").style.display = "block";
				var userdata = localStorage.getItem("userData");
				var userInfo = JSON.parse(userdata);
				console.log("this.selected_vehicleno", this.selected_vehicleno)
				if (this.selected_vehicleno == "" || this.selected_vehicleno == null) {
					this.$fire({
						text: "Please Select Vehicle Number",
						type: "error",
						timer: 30000,
					});
					document.getElementById("overlay").style.display = "none";
					return false;
				}
				if (this.selectFiletype == "text/csv") {
					let data = new FormData();
					data.append("file", this.selectcsvFile);
					data.append("uploadedby", userInfo.userfirstname + " " + userInfo.userlastname);
					data.append("plan_type", this.planUploadedType);
					data.append("vehicleno", this.selected_vehicleno);
					let config = {
						header: {
							"Content-Type": "multipart/form-data",
						},
					};
					console.log("Config", config);
					// return false;
					this.$http.post(this.apiUrl, data, config).then((result) => {
						// console.log("YYY", result);
						document.getElementById("overlay").style.display = "none";
						this.resultMsg = result.body.returnmsg;
						if (result.body.returnmsg === "Successful") {
							// alert("inn");
							this.$fire({
								text: result.body.returnvalue,
								type: "success",
								timer: 30000,
							});
							// this.$router.push('/planUpload').catch(()=>{});
							this.getAllPlanListing();
						} else {
							this.$fire({
								text: result.body.returnvalue,
								type: "error",
								timer: 30000,
							});
						}
					}).catch((ex) => {
						console.log("error", ex);
					});
				} else {
					document.getElementById("overlay").style.display = "none";
					this.$fire({
						text: "Please Upload CSV File Only",
						type: "error",
						timer: 30000,
					});
				}
			},

			clearSearch() {
				this.file = ''
				this.planUploadedType = "";
				this.hub_name = "";
				this.selected_vehicleno = "";
			},

			formatDate: function (date) {
				var d = new Date(date),
					month = "" + (d.getMonth() + 1),
					day = "" + d.getDate(),
					year = d.getFullYear();
				if (month.length < 2) month = "0" + month;
				if (day.length < 2) day = "0" + day;
				return [year, month, day].join("-");
			},

			searchPlan: function () {
				var fromdate = this.selectDateFrom != null ? this.formatDate(this.selectDateFrom) : "";
				var formatdateto = this.selectDateTo != null ? this.formatDate(this.selectDateTo) : "";
				this.isBusy = true;
				const obj = {
					startdate: `${fromdate}`,
					enddate: `${formatdateto}`,
					vehicleno: this.selected_vehicleno,
				};
				if (formatdateto < fromdate) {
					this.$fire({
						text: "To date need to be grater than From date",
						type: "warning",
						timer: 30000,
					});
					this.isBusy = false;
					return false;
				}
				this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getAllPlanListing`, obj).then((result) => {
					this.isBusy = false;
					if (result.body.returnmsg === "Successful") {
						this.items = result.body.returnvalue;
					} else {
						//  this.showdata = []
						this.items = [];
						// this.totalRows = 0;
					}
				}).catch((ex) => {
					console.log("error-----", ex);
				});
			},

			rowClass(item, type) {
				if (item) {
					if (item.update_vehicle_no != null) {
						if (item.vehicleno != item.update_vehicle_no) {
							return 'table-danger'
						}
					}
				}
			},

			getAllPlanListing: function () {
				this.plandata={}

				const obj = {
					startdate: "",
					enddate: "",
					vehicleno: "",
				};
				this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getAllPlanListing`, obj).then((result) => {
					if (result.body.returnmsg === "Successful") {
						this.items = result.body.returnvalue;
					} else {
						//  this.showdata = []
						this.items = [];
						// this.totalRows = 0;
					}
				}).catch((ex) => {
					console.log("error-----", ex);
				});
			},
			isOpen(location) {
				return this.openedLocations.includes(location);
			},
			toggleCollapse(location) {
				const index = this.openedLocations.indexOf(location);
				if (index > -1) {
					this.openedLocations.splice(index, 1);
				} else {
					this.openedLocations.push(location);
				}
			},
			applySearch() {
				let sendObj = {}
				if (this.selectDateFrom && this.selectDateTo && this.selectDateFrom > this.selectDateTo) {
					this.$fire({
						text: `Planning From Date cannot be greater than Planning To Date`,
						type: "error",
						timer: 30000
					});
				}

				this.filters.hubid = this.selected_warehouse
				this.filters.plandatefrom = this.selectDateFrom
				this.filters.plandateto = this.selectDateTo
				this.filters.planstatus = this.planstatus
				this.filters.plantype = this.plantype.toLowerCase()

				const filteredObject = Object.fromEntries(
					Object.entries(this.filters).filter(
						([key, value]) => value !== undefined && value !== null && value !== ''
					)
				);

				sendObj = {
					isadhoc: this.activeTab,
					adminhubid: this.hub_id,
					filters: {}
				}

				Object.entries(filteredObject).forEach(([key, value]) => {
					sendObj.filters[`${key}`] = value
				});

				this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getAllPlan`, sendObj)
					.then(response => response.json())
					.then(data => {
						if (data && data.returnmsg == "Successful") {
							this.totalRecord = data.total
							this.plandata = data.returnvalue
							this.planIds = [...new Set(Object.values(this.plandata).flatMap(plans => plans.map(plan => plan.planid)))];
							// Object.keys(this.plandata).flatMap(city => 
							// this.plandata[city].map(plan => plan.planid)
							// );							

						}
					})
					.catch(error => {
						console.error('Error fetching data:', error);
					});
			},
			downloadConsolidateCsv() {
				let sendObj = {
					planid: this.planIds
				}
				this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/downloadCsvDataPlanDetails`, sendObj, { responseType: 'blob' })
					.then((response) => {
						if (response.data.returnmsg !== "UnSuccessful") {
							const url = window.URL.createObjectURL(new Blob([response.data], { type: 'text/csv' }));
							const link = document.createElement('a');
							link.href = url;
							link.setAttribute('download', `Consolidate_Plan.csv`);
							document.body.appendChild(link);
							link.click();
							link.remove();
						}
					}).catch((ex) => {
						console.log("error", ex);
					});

			},

			//edit plan

			showModal(plandata) {

				console.log("plan data @@##", typeof plandata, plandata)

				if (plandata) {
					this.editplanid = plandata.item.planid ? plandata.item.planid : ''
					let plntype = plandata.item.plantype

					this.showPlanUpdateLog(this.editplanid)


					if (this.editplanid) {

						// var queryString = "?planid=" + this.editplanid;
						let sendObj = {
							planid: this.editplanid
						}

						if (plntype == 'dd') {
							// dd plan detail api
							this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getPlanDetails`, sendObj).then((result) => {
								if (result && result.body.returnmsg == "Successful" && result.body.returnvalue.plandata.length) {
									this.ddplandetaildata = []

									// console.log("plan edit @@@@@@", result)
									this.totalloadtime = result.body.returnvalue.totaltime
									this.totalrecords = result.body.returnvalue.plandata.length
									this.ddplandetaildata = result.body.returnvalue.plandata
									console.log("dd plan detail data", result)
								}
							}).catch((ex) => {
								console.log("error", ex);
							});

						} else {
							//lh plan detail api
							this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getLHPlanDetails`, sendObj).then((result) => {
								if (result && result.body.returnvalue.plandetails) {
									// console.log("lh plan edit @@@@@@", result)
									this.lhplandetaildata = []
									this.lhplandetaildata.push(result.body.returnvalue.plandetails)
									console.log("lh plan detail data", this.lhplandetaildata)
									this.lhhubloadunload = []
									this.lhhubloadunload = result.body.returnvalue.plandetails.hubloadunload
									// console.log("lh plan edit ########", this.lhhubloadunload)
									//middle data
									this.plandetaildata = result.body.returnvalue.plandetails ? result.body.returnvalue.plandetails.details : ''

									// console.log("plan detail data @@ $$ ########", this.plandetaildata)
									this.getplandetaildata(this.plandetaildata);
								}
							}).catch((ex) => {
								console.log("error", ex);
							});
						}
					}

					let plantype = plandata.item.plantype
					if (plantype == "dd") {

						this.$refs['DD-modal'].show()

					}
					else {
						this.$refs['LH-modal'].show()
					}

				}
			},

			// on click view plan detail
			showLHModal(planid, hideloadtime) {
				this.showPlanUpdateLog(planid)

				console.log("plan idd @@", planid)
				console.log("hidetotaltime", hideloadtime)

				if (hideloadtime == 'hidehours') {
					this.hidetimeflag = true
				} else {
					this.hidetimeflag = false
				}

				// var queryString = "?planid=" + planid;
				let sendObj = {
					planid: planid
				}

				this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getPlanDetails`, sendObj).then((result) => {
					if (result && result.body.returnmsg == "Successful" && result.body.returnvalue.plandata.length) {
						this.ddplandetaildata = []

						// console.log("plan edit @@@@@@", result)
						// this.totalloadtime = result.body.returnvalue.totaltime
						this.totalrecords = result.body.returnvalue.plandata.length
						this.ddplandetaildata = result.body.returnvalue.plandata
						console.log("dd plan detail data", result)
						this.$refs['DD-modal'].show()
					}
				}).catch((ex) => {
					console.log("error", ex);
				});
			},

			//plan update log activity
			showPlanUpdateLog(planid) {
				this.planLogData = ''
				if (planid) {
					let sendObj = {
						planid: planid
					}

					this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getPlanLog`, sendObj)
						.then((result) => {
							if (result && result.body.returnmsg == 'Successful') {
								this.planLogData = result.body.returnvalue
								console.log("log data", this.planLogData)
							} else {
								console.log("error", ex);
							}
						}).catch((ex) => {
							console.log("error", ex);
						});
				}
			},

			//reset
			clearFilter() {
				this.filters.hubid = ''
				this.selected_warehouse = ''
				this.filters.plandatefrom = ''
				this.selectDateFrom = ''
				this.filters.plandateto = ''
				this.selectDateTo = ''
				this.filters.planstatus = ''
				this.planstatus = ''
				this.filters.plantype = ''
				this.plantype = ''
				this.plandata= {}

				this.applySearch()
			},
			downloadAdhocFile(planid) {
				let sendObj = {
					planid: planid
				}
				this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/downloadPlancsv`, sendObj, { responseType: 'blob' })
					.then((response) => {
						const url = window.URL.createObjectURL(new Blob([response.data], { type: 'text/csv' }));
						const link = document.createElement('a');
						link.href = url;
						link.setAttribute('download', `Plan-${planid}.csv`);
						document.body.appendChild(link);
						link.click();
						link.remove();
					}).catch((ex) => {
						console.log("error", ex);
					});
			},
			hideModal() {
				this.$refs['DD-modal'].hide()
				this.$refs['LH-modal'].hide()
			},
			rowClass(item) {
				return item.isactive == 0 ? 'table-danger' : ''; // Use Bootstrap class 'table-danger' for red background
			}
		},
	};
</script>
<style lang="scss">
	.planheader a {
		display: block;
		line-height: 35px;
		padding: 0 10px;
		border-radius: 5px;

		&:hover {
			text-decoration: none;
		}
	}

	.graybutton {
		background: #777;
		letter-spacing: 0.5px;
		appearance: none;
		-webkit-appearance: none;
		border-radius: 8px;

		&:hover {
			background: #777;
		}
	}

	.orangebutton {
		background: #f0a910;
		border: none;
		-webkit-appearance: none;
		appearance: none;
		font-size: 16px;

		&:hover {
			background: #f0a910;
		}
	}

	.tabwrapper {
		.tab-content {
			border: none;
			padding: 5px;
		}
	}

	.tabs ul.nav-pills {
		border: none !important;
		margin: 10px 0;

		li {
			width: 50%;

			a {
				border-radius: 8px;
				color: #fff;
				font-weight: bold;
				text-align: center;
				letter-spacing: 1px;
				font-size: 16px;
				background: #777;

			}

		}
	}

	.custom-green-button {
		background-color: hwb(135 36% 3%) !important;
		border-color: rgb(69, 247, 143) !important;
	}

	.tabbutton .active {
		background: #f0a910 !important;
	}

	.container1 {
		max-width: 1200px;
		margin: 0;
		padding: 0;
		margin-left: 1px;
	}

	.form-row1 {
		display: flex;
		align-items: center;
		flex-wrap: nowrap;
	}

	.form-group1 {
		display: flex;
		align-items: center;
		margin-right: 1px;
		flex: 1;
		/* // font-size: 12px; */
	}

	.form-group1:last-child {
		margin-right: 5px;
	}

	.form-group1 label {
		margin-right: 8px;
		white-space: nowrap;
		width: auto;
		font-size: 12px;
	}

	.form-group1 input,
	.form-group1 select {
		width: 135px;
		font-size: 11px;
	}

	.form-control1 {
		min-width: 144px;
		/* // font-size: 10px !important; */
	}

	.custom-date-picker {
		min-width: 116px;
		font-size: 12px !important;
	}

	.custom-date-picker input {
		font-size: 13.7px !important;
	}


	.btn-black {
		color: black !important;
	}

	label {
		margin-bottom: 0.5rem;
		display: block;
	}

	.editgreybtn {
		background: #e4e1e1;
		padding: 4px 12px;
		line-height: normal;
		border-radius: 8px;
		border-top: 3px solid #9e9d9d;
		color: #000;
		letter-spacing: 1px;

		&:hover {
			color: #000;
			text-decoration: none;
		}
	}

	.editwhitebtn {
		background: #fff;
		padding: 4px 12px;
		line-height: normal;
		border-radius: 8px;
		border: 1px solid #ccc;
		color: #000;
		letter-spacing: 1px;
		box-shadow: 1px 3px 3px 0px #ccc;

		&:hover {
			color: #000;
			text-decoration: none;
		}

	}
</style>